
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bmc-control-m",
      function () {
        return require("private-next-pages/bmc-control-m/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bmc-control-m"])
      });
    }
  